import { t } from "i18next";
import React, { useEffect, useState } from "react";
import AccessesTable from "./table/AccessesTable";
import { Button, Text } from "@radix-ui/themes";
import { AccessToken, PersonById } from "../../../../types/types";
import { useFetch } from "../../../../hooks/useFetch";
import AddAccess from "./AddAccess";
import _ from "lodash";
import { Separator } from "../../../../ui/Separator";

type Props = {
  id: string | undefined;
  currentPerson: PersonById | undefined;
  updatePerson: Function;
};

const StaffAccessTab = ({ id, currentPerson, updatePerson }: Props) => {
  const [accessTokens, setAccessTokens] = useState<AccessToken[]>();

  const [{ response, isLoading, error }, doFetchAccessTokens] = useFetch(`/directories/personnels/${id}/access_tokens`);

  useEffect(() => {
    doFetchAccessTokens();
  }, []);

  useEffect(() => {
    setAccessTokens(response?.data as unknown as AccessToken[]);
  }, [response]);

  let nodes = accessTokens?.map((token) => {
    return {
      id: token.id,
      at: token.attributes.at,
      status: token.attributes.status,
      access_token_id: token.attributes.access_token_id,
      access_token_type: token.attributes.access_token_type,
    };
  });

  nodes = _.sortBy(nodes, []);
  let data = { nodes };

  return (
    <div className="relative flex flex-col w-full h-full overflow-hidden bg-background">
      <div className="flex flex-none w-full h-24 text-base gap-2 items-center justify-between px-6">
        <div className="flex flex-col space-y-1">
          <span className="text-2xl font-semibold">{t('access_token_change')}</span>
        </div>
      </div>
      <div className="pt-2 flex flex-col w-full gap-8 px-6">
        <AddAccess itemId={id} updateList={doFetchAccessTokens} />
        {accessTokens ? <AccessesTable data={data} equipmentId={id} updateList={doFetchAccessTokens} /> : ""}
      </div>
    </div>
  );
};

export default StaffAccessTab;
